import { createPositionAssignmentsHttpRepository } from '@src/main/modules/reports/positionassignment/infrastructure/repository/PositionAssignmentsHttpRepository';

import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useDownloadPositionAssignmentPdf = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createPositionAssignmentsHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (evaluationId: string) => {
      if (!repository) throw new Error('Repository not initialized');
      return await repository.downloadPdf(evaluationId);
    },
  });
};
